import {useState, useEffect} from "react";
import {dataFetch, setTrack} from "utils";
import {Trans, useTranslation} from "react-i18next";
import {Checkbox} from "parts";
import {Paysafe} from "parts/paywall";

export function Plan({
  children, index, discount, onChange, strict, listInput = [],
  path = 'prices', data, method = 'GET',
  itemContent, onChangeResponse, book, price, actived
}) {
  const {t, i18n} = useTranslation('common', {keyPrefix: 'paywall.plan'})

  // const {
  //   catchError
  // } = usePayment({data})

  const
    [list, setList] = useState(listInput),
    [active, setActive] = useState(listInput[0]),
    isForce = window.sessionStorage.getItem('force')

  // const A61 =
  //   window.landing === LandingEnum.default &&
  //   i18n.resolvedLanguage === 'en' &&
  //   window.sessionStorage.getItem('country_code') === 'IN'
  //     ? getExperiment('A61')
  //     : {value: 'A'}

  // const AR98 = getExperiment('AR98', 'A')

  let code = ''

  // switch (AR98.value) {
  //   case 'B':
  //     code = '&code=US_2'
  //     break
  // }

  // if (A61.value === 'B')
  //   code = '&code=IN_1'
  // else if (A61.value === 'C')
  //   code = '&code=IN_2'

  useEffect(() => {
    if (actived)
      setActive(actived)
  }, [actived])

  useEffect(() => {
    if (listInput.length)
      return

    const callback = (response) => {
      if (!Array.isArray(response))
        response = [response]

      if (onChangeResponse)
        response = onChangeResponse(response)

      setList(response)

      let isActive = false

      for (const item of response) {
        if (
          item.selected
          // item.selected && A40.value === 'A' ||
          // A40.value === 'B' && i === response.length - 1 // && item.period === '3month'
        ) {
          isActive = true
          setActive(item)

          if (onChange)
            onChange(item)

          break
        }
      }

      if (!isActive) {
        setActive(response[0])

        if (onChange)
          onChange(response[0])
      }
    }

    if (price)
      callback(price)
    else {
      const url = `${process.env.REACT_APP_API_URI}web-payments/${path}?lang=${i18n.resolvedLanguage}&uid=${window._uid || window.localStorage.getItem('uid')}${isForce ? '&force=1' : ''}${code}`
      dataFetch(
        // `${process.env.REACT_APP_API_URI}web-payments/${path}?lang=${i18n.resolvedLanguage}${isForce ? '&force=1' : ''}${A52.value === 'B' ? '&testId=A52' : ''}`,
        url,
        data,
        callback,
        method,
        () => setTrack('checkout_error', {message: `plan fetch ${url}`})
        // (r) => catchError(r, `plan fetch ${url}`, false, false)
      )
    }
  }, [i18n.resolvedLanguage])

  function handleChange(item) {
    setActive(item)

    if (onChange)
      onChange(item)
  }

  return (
    <>
      <div id={'plan'} className={'items w-100'} style={list?.[0]?.promo ? {marginTop: 10} : {}}>
        {
          !active &&
          <iframe title={'Loading...'} src={process.env.PUBLIC_URL + '/static/loader.html'} width="100%" height={74} frameBorder="0" style={discount ? {} : {margin: '94px 0'}}/>
        }
        {
          list.map((item) => {
            let
              checked = active?.id === item.id,
              promo = item.promo

            if (book)
              promo = item[book].promo[i18n.resolvedLanguage]

            // item.standardPrice = 19.9;

            return (
              <div key={item.id}
                   className={'block-plan' + (item.popular ? ' popular' : '') + (checked ? ' active' : '')}
                   style={{position: 'relative'}}
                   onClick={() => handleChange(item)}>
                {
                  promo &&
                  <div className={'promo small'}><em>{promo}</em></div>
                }
                <div className={'item'}>
                  {
                    list.length > 1 &&
                    <Checkbox type={'radio'} name={'plan' + (index ? '-' + index : '')} checked={checked} readOnly={true}/>
                  }
                  {
                    itemContent
                      ? itemContent(item)
                      :
                      <>
                        <div className={'w-100 text-start'}>
                          <strong>{item.name}</strong>
                          <p>
                            <em className={'small'}>{item.currency} {item.fullPrice}</em>&nbsp;
                            {
                              (item.standardPrice || item.price) &&
                              <s className={'note lg'}>{item.currency} {item.standardPrice || item.price}</s>
                            }
                          </p>
                        </div>
                        <div className={'nowrap'}>
                          <sup>{item.currencySymbol}</sup>
                          <big>{Math.trunc(item.dayPrice)}</big>
                          <div>
                            <Trans i18nKey="perDay" t={t}>
                              <em>{{dayPrice: Math.round(item.dayPrice % 1 * 100)}}</em>
                              <small>PER DAY</small>
                            </Trans>
                          </div>
                        </div>
                      </>
                  }
                </div>
              </div>
            )
          })
        }
      </div>

      {children}

      {
        !strict &&
        <>
          <Paysafe/>
          <img src={'/static/img/paywall/logos.png'} alt="stripe" className={'mw-100'} width={326} height={22}
               style={{padding: '0 15px'}}/>
        </>
      }
    </>
  )
}